import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Snackbar,
  Alert
} from '@mui/material';
import { resetpassword, sendotp, verifyotp } from '../services';

const ForgotPasswordDialog = ({ open, onClose }) => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [password, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };
  const handleNextEmail = async () => {
    if (!email) return alert('Please enter your email');

    try {
        const reposnse = await sendotp(email);
        if (reposnse.status === 200) {
            setSnackbar({
                open: true,
                message: "OTP send successful!",
                severity: "success",
              });
          setStep(2);
        }
  
      } catch (err) {
        setSnackbar({
            open: true,
            message: err?.response?.data?.message || "Login failed. Please try again.",
            severity: "error",
          });
      }
  };

  const handleNextOtp = async () => {
    if (!otp) return alert('Please enter OTP');

    try {
        const reposnse = await verifyotp(email,otp);
        if (reposnse.status === 200) {
            setSnackbar({
                open: true,
                message: "OTP verify successful!",
                severity: "success",
              });
              setStep(3);
        }
      } catch (err) {
        setSnackbar({
            open: true,
            message: err?.response?.data?.message || "Login failed. Please try again.",
            severity: "error",
          });
      }
   
  };

  const handleResetPassword = async () => {
    if (!password || !confirmPassword) return alert('Please fill all fields');
    if (password !== confirmPassword) return alert('Passwords do not match');

    // 👉 Call API to reset password
    const payload = { otp, password };
    console.log('Resetting password with data:', payload);
    try {
        const reposnse = await resetpassword(payload);
        if (reposnse.status === 200) {
            setSnackbar({
                open: true,
                message: "Forget Password successful!",
                severity: "success",
              });
              setStep(1);
              setEmail('');
              setOtp('');
              setNewPassword('');
              setConfirmPassword('');
              onClose();
        }
      } catch (err) {
        setSnackbar({
            open: true,
            message: err?.response?.data?.message || "Login failed. Please try again.",
            severity: "error",
          });
      }
    // Reset state and close
  
  };

  const handleBack = () => setStep((prev) => prev - 1);

  return (
    <>
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Forgot Password</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
        {step === 1 && (
          <>
            <Typography>Enter your registered email:</Typography>
            <TextField
              label="Email"
              type="email"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </>
        )}

        {step === 2 && (
          <>
            <Typography>Enter the OTP sent to your email:</Typography>
            <TextField
              label="OTP"
              type="text"
              fullWidth
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
          </>
        )}

        {step === 3 && (
          <>
            <Typography>Set your new password:</Typography>
            <TextField
              label="New Password"
              type="password"
              fullWidth
              value={password}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <TextField
              label="Confirm Password"
              type="password"
              fullWidth
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </>
        )}
      </DialogContent>

      <DialogActions>
        {step > 1 && <Button onClick={handleBack}>Back</Button>}
        <Button onClick={onClose}>Cancel</Button>

        {step === 1 && (
          <Button variant="contained" onClick={handleNextEmail}>Send OTP</Button>
        )}
        {step === 2 && (
          <Button variant="contained" onClick={handleNextOtp}>Verify OTP</Button>
        )}
        {step === 3 && (
          <Button variant="contained" onClick={handleResetPassword}>Reset Password</Button>
        )}
      </DialogActions>
    </Dialog>
         <Snackbar
         open={snackbar.open}
         autoHideDuration={4000}
         onClose={handleSnackbarClose}
         anchorOrigin={{ vertical: "top", horizontal: "right" }}
       >
         <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
           {snackbar.message}
         </Alert>
       </Snackbar>
      </>
  );
};

export default ForgotPasswordDialog;
